import { useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

// @mui material components
import { Tabs, Tab, Box, Card } from "@mui/material";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Components
import GeneralSettings from "./GeneralSettings";
import AlertMessage from "components/UI/AlertMessage";
import useAlert from "hooks/useAlert";
import useAPI from "hooks/useAPI";

// Custom TabPanel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`interface-settings-tabpanel-${index}`}
      aria-labelledby={`interface-settings-tab-${index}`}
      {...other}
    >
      {value === index && <SoftBox sx={{ p: 3 }}>{children}</SoftBox>}
    </div>
  );
}

// PropTypes for TabPanel
TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

const InterfaceSettings = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const { errorState, showAlert } = useAlert();
  const { api } = useAPI();
  const pagesList = [
    {
      name: t("lang.interface_settings"),
      route: "",
    },
  ];

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />
      <SoftBox py={3}>
        <SoftBox mb={3}>
          <Card>
            <SoftBox p={2}>
              <SoftTypography variant="h6" fontWeight="medium">
                {t("lang.interface_settings")}
              </SoftTypography>
            </SoftBox>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={activeTab}
                onChange={handleTabChange}
                aria-label="interface settings tabs"
                sx={{ px: 2 }}
              >
                <Tab
                  value={0}
                  label={t("lang.general_settings")}
                  id="interface-settings-tab-1"
                  aria-controls="interface-settings-tabpanel-1"
                />
                {/* <Tab
                  value={1}
                  label={t("lang.main_menu_ordering")}
                  id="interface-settings-tab-0"
                  aria-controls="interface-settings-tabpanel-0"
                /> */}
              </Tabs>
            </Box>

            <TabPanel value={activeTab} index={0}>
              <GeneralSettings showAlert={showAlert} api={api} />
            </TabPanel>

            {/* <TabPanel value={activeTab} index={1}>
              <SoftTypography variant="h6" gutterBottom>
                {t("lang.main_menu_ordering")}
              </SoftTypography>
              <SoftTypography variant="body2" color="text">
                {t("lang.main_menu_ordering_description")}
              </SoftTypography>
              <SoftBox mt={2}>
                <SoftTypography variant="body2">
                  • {t("lang.default_page_layout_options")}
                </SoftTypography>
                <SoftTypography variant="body2">
                  • {t("lang.navigation_preferences")}
                </SoftTypography>
                <SoftTypography variant="body2">
                  • {t("lang.sidebar_behavior_settings")}
                </SoftTypography>
              </SoftBox>
            </TabPanel> */}
          </Card>
        </SoftBox>
      </SoftBox>
      <AlertMessage {...errorState} />
    </DashboardLayout>
  );
};

export default InterfaceSettings;
